import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { RootState } from '../../redux/store'
import { addBook } from '../../redux/book.slice'
import { CreateBook } from '../../types/book'
import styles from './bookForm.module.scss'
import { loadAllAuthors } from '../../redux/author.slice'
import { loadAllPublishers } from '../../redux/publisher.slice'
import { Author } from '../../types/author'
import { Publisher } from '../../types/publisher'
interface BookFormProps {
  authors: Author[]
  publishers: Publisher[]
  addBook: (book: CreateBook) => void
  loadAllAuthors: () => void
  loadAllPublishers: () => void
}

const BookForm = ({
  authors,
  publishers,
  addBook,
  loadAllAuthors,
  loadAllPublishers,
}: BookFormProps) => {
  const [nameEng, setNameEng] = useState<string>('')
  const [nameEsp, setNameEsp] = useState<string>('')
  const [image, setImage] = useState<string>()
  const [category, setCategory] = useState<string>('')
  const [publisher, setPublisher] = useState<string>('')
  const [author, setAuthor] = useState<string>('')
  const [pagesCount, setPagesCount] = useState<number>()
  const [language, setLanguage] = useState<string>('')
  const [year, setYear] = useState<number>()
  const [price, setPrice] = useState<number>()
  const [infoEng, setInfoEng] = useState<string>('')
  const [infoEsp, setInfoEsp] = useState<string>('')

  useEffect(() => {
    loadAllAuthors()
    loadAllPublishers()
  }, [])

  const addBookHandler = () => {
    if (
      nameEng &&
      nameEsp &&
      image &&
      category &&
      author &&
      publisher &&
      pagesCount &&
      language &&
      year &&
      price &&
      infoEng &&
      infoEsp
    ) {
      const data: CreateBook = {
        name: {
          eng: nameEng,
          esp: nameEsp,
        },
        info: {
          eng: infoEng,
          esp: infoEsp,
        },
        image: image!,
        category: category.trim().split(' '),
        publisher,
        author,
        pagesCount,
        language,
        year,
        price,
      }
      addBook(data)
    }
  }

  return (
    <div className={styles.root}>
      <span className={styles.formTitle}>Add book</span>
      <input
        value={nameEng}
        className={styles.textInput}
        onChange={(e) => setNameEng(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="nameEng"
      />
      <input
        value={nameEsp}
        className={styles.textInput}
        onChange={(e) => setNameEsp(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="nameEsp"
      />
      <input
        value={image}
        className={styles.textInput}
        onChange={(e) => setImage(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="image"
      />
      <input
        value={language}
        className={styles.textInput}
        onChange={(e) => setLanguage(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="language"
      />
      <input
        value={category}
        className={styles.textInput}
        onChange={(e) => setCategory(e.target.value)}
        type="text"
        name=""
        id=""
        placeholder="category"
      />
      <select
        name="author"
        id="author"
        className={styles.inputSelect}
        onChange={(e) => setAuthor(e.target.value)}
      >
        {authors?.length > 0 &&
          authors.map((author: Author, index: number) => (
            <option key={`${index}-${author.id}`} value={author.id}>
              {author.name.eng}
            </option>
          ))}
      </select>
      <select
        name="publishers"
        id="publishers"
        className={styles.inputSelect}
        onChange={(e) => setPublisher(e.target.value)}
      >
        {publishers?.length > 0 &&
          publishers.map((publisher: Publisher, index: number) => (
            <option key={`${index}-${publisher.id}`} value={publisher.id}>
              {publisher.name.eng}
            </option>
          ))}
      </select>
      <input
        value={pagesCount}
        className={styles.textInput}
        onChange={(e) => setPagesCount(+e.target.value)}
        type="number"
        name="pagesCount"
        id="pagesCount"
        placeholder="pageCaunt"
      />
      <input
        value={year}
        className={styles.textInput}
        onChange={(e) => setYear(+e.target.value)}
        type="number"
        name=""
        id=""
        placeholder="year"
      />
      <input
        value={price}
        className={styles.textInput}
        onChange={(e) => setPrice(+e.target.value)}
        type="number"
        name=""
        id=""
        step="0.01"
        placeholder="price"
      />
      <textarea
        value={infoEng}
        className={styles.textArea}
        onChange={(e) => setInfoEng(e.target.value)}
        name=""
        id=""
        placeholder="infoEng"
      />
      <textarea
        value={infoEsp}
        className={styles.textArea}
        onChange={(e) => setInfoEsp(e.target.value)}
        name=""
        id=""
        placeholder="infoEsp"
      />
      <input
        onClick={addBookHandler}
        type="button"
        value="Add book"
        className={styles.button}
      />
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  authors: state.author.authors,
  publishers: state.publisher.publishers,
})

export default connect(mapStateToProps, {
  loadAllAuthors,
  loadAllPublishers,
  addBook,
})(BookForm)
